var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
        _vm.$style.headline,
        _vm.$slots.action ? _vm.$style.headlineAction : '',
        _vm.props.center ? _vm.$style.headlineCenter : '' ]},[_c('div',{class:_vm.$style.titles},[_c('h2',{class:_vm.$style.title},[_vm._t("default")],2),(_vm.$slots.subtitle)?_c('p',{class:_vm.$style.subtitle},[_vm._t("subtitle")],2):_vm._e()]),_vm._t("action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }